import { pushDataLayer } from '@/utilities/dataLayer/push';

import type { BusinessLine } from '@/constants/dataLayer';
import { DATA_LAYER_EVENTS, ECOMMERCE_CURRENCY } from '@/constants/dataLayer';

type TrackPurchaseFailedParams = {
    transactionId: string;
    value: number;
    businessLine: BusinessLine;
    failureReason: string;
};

export const trackPurchaseFailed = ({ transactionId, value, businessLine, failureReason }: TrackPurchaseFailedParams): void => {
    pushDataLayer({
        event: DATA_LAYER_EVENTS.PURCHASE_FAILED,
        ecommerce: {
            transaction_id: transactionId,
            value,
            currency: ECOMMERCE_CURRENCY,
            business_line: businessLine
        },
        payment: {
            failure_reason: failureReason
        }
    });
};
